import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=2095c8f8&scoped=true"
import script from "./ItemCard.vue?vue&type=script&lang=js"
export * from "./ItemCard.vue?vue&type=script&lang=js"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=2095c8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095c8f8",
  null
  
)

export default component.exports